const defaultSetting: AnyListen.AppSetting = {
  version: '1.0.3',

  'common.windowSizeId': 3,
  'common.fontSize': 16,
  'common.startInFullscreen': false,
  'common.langId': null,
  'common.font': '',
  'common.isShowAnimation': true,
  'common.isAgreePact': false,
  'common.playBarProgressStyle': 'centerControl',
  'common.transparentWindow': true,
  'common.tryAutoUpdate': true,
  'common.allowPreRelease': false,
  'common.showChangeLog': true,
  'common.enableTrash': true,
  'common.enableDebug': false,

  'player.startupAutoPlay': false,
  'player.togglePlayMethod': 'listLoop',
  'player.playQuality': '128k',
  'player.isShowTaskProgess': true,
  'player.volume': 1,
  'player.isMute': false,
  'player.playbackRate': 1,
  'player.preservesPitch': true,
  'player.mediaDeviceId': 'default',
  'player.isMediaDeviceChangedPausePlay': false,
  'player.isShowLyricTranslation': false,
  'player.isShowLyricRoma': false,
  'player.isSwapLyricTranslationAndRoma': false,
  'player.isS2t': false,
  'player.isPlayAwlrc': true,
  'player.isSavePlayTime': true,
  'player.audioVisualization': false,
  'player.waitPlayEndStop': true,
  'player.waitPlayEndStopTime': '',
  'player.autoSkipOnError': true,
  'player.isAutoCleanPlayedList': false,
  'player.isShowStatusBarLyric': false,
  'player.isShowTitleLyric': false,
  'player.isShowMediaSessionLyric': false,
  'player.soundEffect.convolution.fileName': '',
  'player.soundEffect.convolution.mainGain': 10,
  'player.soundEffect.convolution.sendGain': 0,
  'player.soundEffect.biquadFilter.hz31': 0,
  'player.soundEffect.biquadFilter.hz62': 0,
  'player.soundEffect.biquadFilter.hz125': 0,
  'player.soundEffect.biquadFilter.hz250': 0,
  'player.soundEffect.biquadFilter.hz500': 0,
  'player.soundEffect.biquadFilter.hz1000': 0,
  'player.soundEffect.biquadFilter.hz2000': 0,
  'player.soundEffect.biquadFilter.hz4000': 0,
  'player.soundEffect.biquadFilter.hz8000': 0,
  'player.soundEffect.biquadFilter.hz16000': 0,
  'player.soundEffect.panner.enable': false,
  'player.soundEffect.panner.soundR': 5,
  'player.soundEffect.panner.speed': 50,
  'player.soundEffect.pitchShifter.playbackRate': 1,
  'player.ignoreLocalLyrics': false,

  'playDetail.isZoomActiveLrc': true,
  'playDetail.style.fontSize': 100,
  'playDetail.style.align': 'left',
  'playDetail.style.fontWeight': true,
  'playDetail.isDelayScroll': true,
  'playDetail.isDynamicBackground': true,
  'playDetail.coverStyle': 'cd',

  'list.isShowActionBtn': true,
  'list.addMusicLocationType': 'top',

  'desktopLyric.enable': false,
  'desktopLyric.isLock': false,
  'desktopLyric.isAlwaysOnTop': false,
  'desktopLyric.isAlwaysOnTopLoop': false,
  'desktopLyric.isShowTaskbar': false,
  'desktopLyric.fullscreenHide': true,
  'desktopLyric.pauseHide': true,
  'desktopLyric.isLockScreen': true,
  'desktopLyric.isHoverHide': false,
  'desktopLyric.mode': 'classic',

  'desktopLyric.classic.x': null,
  'desktopLyric.classic.y': null,
  'desktopLyric.classic.showExtendedLyrics': true,
  'desktopLyric.classic.style.font': '',
  'desktopLyric.classic.style.fontSize': 26,
  'desktopLyric.classic.style.opacity': 100,
  'desktopLyric.classic.style.align': 'bottom',
  'desktopLyric.classic.style.lyricUnplayColor': 'rgba(87, 143, 255, 1)',
  'desktopLyric.classic.style.lyricPlayedColor': 'rgba(39, 249, 192, 1)',
  'desktopLyric.classic.style.lyricShadowColor': 'rgba(0, 0, 0, 0.6)',
  'desktopLyric.classic.style.isFontWeightFont': false,
  'desktopLyric.classic.style.isFontWeightLine': false,
  'desktopLyric.classic.style.isFontWeightExtended': false,

  'desktopLyric.multiLine.width': 450,
  'desktopLyric.multiLine.height': 300,
  'desktopLyric.multiLine.x': null,
  'desktopLyric.multiLine.y': null,
  'desktopLyric.multiLine.isDelayScroll': false,
  'desktopLyric.multiLine.scrollAlign': 'center',
  'desktopLyric.multiLine.direction': 'horizontal',
  'desktopLyric.multiLine.style.align': 'center',
  'desktopLyric.multiLine.style.font': '',
  'desktopLyric.multiLine.style.fontSize': 26,
  'desktopLyric.multiLine.style.lineGap': 15,
  'desktopLyric.multiLine.style.lyricUnplayColor': 'rgba(255, 255, 255, 1)',
  'desktopLyric.multiLine.style.lyricPlayedColor': 'rgba(113, 135, 255, 1)',
  'desktopLyric.multiLine.style.lyricShadowColor': 'rgba(0, 0, 0, 0.6)',
  'desktopLyric.multiLine.style.opacity': 100,
  // 'desktopLyric.style.ellipsis': false,
  'desktopLyric.multiLine.style.isZoomActiveLrc': true,
  'desktopLyric.multiLine.style.isFontWeightFont': true,
  'desktopLyric.multiLine.style.isFontWeightLine': true,
  'desktopLyric.multiLine.style.isFontWeightExtended': true,

  'sync.webdav.enable': false,
  'sync.webdav.debugEnable': false,
  'sync.webdav.url': '',
  'sync.webdav.username': '',
  'sync.webdav.password': '',
  'sync.webdav.path': '',
  'sync.webdav.syncEnable.list': true,
  'sync.webdav.syncEnable.dislike': true,

  'backup.backupPath': '',

  'download.savePath': '',
  'download.fileName': '%name% - %singer%',

  'onlineResource.enable': false,
  'onlineResource.tipSearchSource': '',

  'network.proxy.enable': false,
  'network.proxy.host': '',
  'network.proxy.port': '',

  'network.proxyAllResources': true,

  'tray.enable': false,
  // 'tray.isToTray': false,
  'tray.themeId': 1,

  // 'theme.id': 'blue_plus',
  'theme.id': 'blue2',
  'theme.lightId': 'blue2',
  'theme.darkId': 'black',

  'extension.onlineExtensionHost': '',
  'extension.ghMirrorHosts': 'https://ghproxy.net\nhttps://gh-proxy.com\nhttps://ghproxy.cn\nhttps://github.moeyy.xyz',
}

// 使用新年皮肤
if (new Date().getMonth() < 2) {
  defaultSetting['theme.id'] = 'happy_new_year'
  defaultSetting['desktopLyric.multiLine.style.lyricPlayedColor'] = 'rgba(255, 57, 71, 1)'

  defaultSetting['desktopLyric.classic.style.lyricUnplayColor'] = 'rgba(255, 57, 71, 1)'
  defaultSetting['desktopLyric.classic.style.lyricPlayedColor'] = 'rgba(255, 242, 87, 1)'
  defaultSetting['desktopLyric.classic.style.lyricShadowColor'] = 'rgba(111, 0, 0, 0.58)'
}

export default defaultSetting
